import { useCallback, useState } from 'react';

export interface UsePhysicalCountActionButtonsProps {
  onNewSession: () => void;
  onExport: (locationId: number) => void;
  locations: Array<{ id: number; name: string }>;
}

export const usePhysicalCountActionButtons = ({
  onNewSession,
  onExport,
  locations: _locations,
}: UsePhysicalCountActionButtonsProps) => {
  const [exportAnchorEl, setExportAnchorEl] = useState<null | HTMLElement>(null);
  const exportMenuOpen = Boolean(exportAnchorEl);

  const handleNewSession = useCallback(() => {
    onNewSession();
  }, [onNewSession]);

  const handleExportClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setExportAnchorEl(event.currentTarget);
  }, []);

  const handleExportClose = useCallback(() => {
    setExportAnchorEl(null);
  }, []);

  const handleExportLocation = useCallback(
    (locationId: number) => {
      onExport(locationId);
      setExportAnchorEl(null);
    },
    [onExport],
  );

  return {
    exportAnchorEl,
    exportMenuOpen,
    handleNewSession,
    handleExportClick,
    handleExportClose,
    handleExportLocation,
  };
};
